// @flow

import gql from 'graphql-tag';

const appCalloutQuery = gql`
  query appCalloutQuery($slug: String!) {
    appBySlug(slug: $slug) {
      id
      image
      name
      primaryColor
      isUpcoming
    }
  }
`;

export default appCalloutQuery;
